import { computeWeeksOfStock } from "./UrgencyCalculator.ts";

export interface BeforeAfterPoCell {
  projectedStock: number;
  poQty: number;
  total: number;
  weeksOfStock: number;
}

export function buildBeforeAfterPoCell({
  projectedStock,
  poQty,
  dailyRateOfSale,
}: {
  projectedStock: number;
  poQty: number;
  dailyRateOfSale: number;
}): BeforeAfterPoCell {
  const total = projectedStock + poQty;
  return {
    projectedStock,
    poQty,
    total,
    weeksOfStock: computeWeeksOfStock(total, dailyRateOfSale).weeksOfStock,
  };
}

export function isBeforeAfterPoCell(
  value: unknown
): value is BeforeAfterPoCell {
  if (typeof value !== "object" || value === null) {
    return false;
  }
  const cell = value as Record<string, unknown>;
  return (
    typeof cell.projectedStock === "number" &&
    typeof cell.poQty === "number" &&
    typeof cell.total === "number" &&
    typeof cell.weeksOfStock === "number"
  );
}

export function beforeAfterPoQty(value: unknown): number {
  if (isBeforeAfterPoCell(value)) {
    return value.poQty;
  }
  return typeof value === "number" ? value : 0;
}

export function formatBeforeAfterPoCell(cell: BeforeAfterPoCell): string {
  return `Proj ${String(cell.projectedStock)} · PO ${String(cell.poQty)} · Tot ${String(cell.total)} · WOS ${String(cell.weeksOfStock)}`;
}
